if (!customElements.get('gpg-mobile-buy')) {
  customElements.define('gpg-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info') || document.querySelector('product-info[id^="MainProduct-"]');
      this.button = this.querySelector('[data-submit]');
      if (!this.root || !this.button) return;
      this.dataset.sectionId = this.root.dataset.section;
      this.clickHandler = () => {
        const submit = this.root.querySelector('#ProductSubmitButton-' + this.dataset.sectionId);
        if (submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true') submit.click();
      };
      this.button.addEventListener('click', this.clickHandler);
      this.sync = () => {
        const submit = this.root.querySelector('#ProductSubmitButton-' + this.dataset.sectionId);
        const price = this.root.querySelector('[id="price-' + this.dataset.sectionId + '"] .price');
        if (!submit) { this.hidden = true; return; }
        const rect = submit.getBoundingClientRect();
        const visible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        this.hidden = !window.matchMedia('(max-width: 749px)').matches || visible || rect.top > window.innerHeight;
        this.button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        this.button.textContent = submit.querySelector('span')?.textContent.trim() || submit.textContent.trim();
        const regular = price?.querySelector('.price__sale .price-item--sale') || price?.querySelector('.price__regular .price-item');
        if (regular) this.querySelector('[data-price]').textContent = regular.textContent.trim();
      };
      this.onScroll = () => { if (this.frame) return; this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); }); };
      window.addEventListener('scroll', this.onScroll, {passive: true});
      window.addEventListener('resize', this.onScroll);
      this.observer = new MutationObserver(this.onScroll);
      const info = this.root.querySelector('.product__info-container');
      if (info) this.observer.observe(info, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled','aria-disabled','class']});
      this.sync();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.clickHandler);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
